import { Listing } from '../types';

export const mockListings: Listing[] = [
  {
    id: '1',
    address: '245 Main Street',
    city: 'Royersford',
    state: 'PA',
    zip: '19468',
    price: 425000,
    beds: 4,
    baths: 2.5,
    sqft: 2400,
    image: 'https://images.unsplash.com/photo-1564013799919-ab600027ffc6?w=800&q=80',
    images: [{ url: 'https://images.unsplash.com/photo-1564013799919-ab600027ffc6?w=800&q=80' }],
    status: 'sold',
    soldDate: '2024-12-15'
  },
  {
    id: '2',
    address: '782 Oak Avenue',
    city: 'Collegeville',
    state: 'PA',
    zip: '19426',
    price: 375000,
    beds: 3,
    baths: 2,
    sqft: 1850,
    image: 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=800&q=80',
    images: [{ url: 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=800&q=80' }],
    status: 'sold',
    soldDate: '2024-11-28'
  },
  {
    id: '3',
    address: '1120 Walnut Lane',
    city: 'Phoenixville',
    state: 'PA',
    zip: '19460',
    price: 525000,
    beds: 5,
    baths: 3,
    sqft: 3200,
    image: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=800&q=80',
    images: [{ url: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=800&q=80' }],
    status: 'sold',
    soldDate: '2024-11-10'
  },
  {
    id: '4',
    address: '56 Cherry Hill Road',
    city: 'Spring City',
    state: 'PA',
    zip: '19475',
    price: 299000,
    beds: 3,
    baths: 1.5,
    sqft: 1600,
    image: 'https://images.unsplash.com/photo-1605276374104-dee2a0ed3cd6?w=800&q=80',
    images: [{ url: 'https://images.unsplash.com/photo-1605276374104-dee2a0ed3cd6?w=800&q=80' }],
    status: 'sold',
    soldDate: '2024-10-22'
  },
  {
    id: '5',
    address: '890 Elm Street',
    city: 'Trappe',
    state: 'PA',
    zip: '19426',
    price: 450000,
    beds: 4,
    baths: 2.5,
    sqft: 2650,
    image: 'https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?w=800&q=80',
    images: [{ url: 'https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?w=800&q=80' }],
    status: 'sold',
    soldDate: '2024-10-05'
  },
  {
    id: '6',
    address: '333 Birch Drive',
    city: 'Limerick',
    state: 'PA',
    zip: '19468',
    price: 389000,
    beds: 3,
    baths: 2,
    sqft: 2100,
    image: 'https://images.unsplash.com/photo-1600566753086-00f18fb6b3ea?w=800&q=80',
    images: [{ url: 'https://images.unsplash.com/photo-1600566753086-00f18fb6b3ea?w=800&q=80' }],
    status: 'sold',
    soldDate: '2024-09-18'
  }
];
